import React, { useEffect, useState } from 'react';
import managerAPI from "../../apis/manager/managerAPI";
import Select from "react-select";
import { v4 as uuidv4 } from 'uuid';
import Swal from "sweetalert2";
import configurationAPI from '../../apis/configuration/configurationAPI';

function DesignationConfiguration({ rolesLoading, roles }) {
    const [finalUpdatedDesignations, setFinalUpdatedDesignations] = useState({ deleted: [], added: [] });
    const [designations, setDesignations] = useState([]);
    const [designationsLoading, setDesignationsLoading] = useState(false);
    const [roleForDesignation, setRoleForDesignation] = useState(null);
    const [newDesignations, setNewDesignations] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [designationsForDuplicationCheck, setDesignationsForDuplicationCheck] = useState([]);

    useEffect(() => {
        if (!roleForDesignation) {
            setDesignations([]);
            setDesignationsForDuplicationCheck([]);
            setNewDesignations([]);
            setFinalUpdatedDesignations({ deleted: [], added: [] });
        }
    }, [roleForDesignation]);

    const fetchDesignations = async (roleId) => {
        if (roleId) {
            try {
                setDesignationsLoading(true);
                const response = await managerAPI.getMasterOnRole(roleId);
                if (response) {
                    setDesignations(response?.designations || []);
                    setDesignationsForDuplicationCheck(response?.designations || []);
                }
            } catch (err) {
                console.error("Error fetching designations:", err);
            } finally {
                setDesignationsLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchDesignations(roleForDesignation?.value);
    }, [roleForDesignation?.value]);

    const handleAddDesignationInput = () => {
        setNewDesignations([...newDesignations, { id: uuidv4(), name: '' }]);
    };

    const handleDesignationChange = (id, value, isNew) => {
        if (isNew) {
            setNewDesignations(prev =>
                prev.map(designation =>
                    designation?.id === id ? { ...designation, name: value } : designation
                )
            );
        } else {
            setDesignations(prev =>
                prev.map(designation =>
                    designation?.id === id ? { ...designation, name: value } : designation
                )
            );
        }

    };

    const submitDesignationChanges = async (reqBody) => {
        try {
            setIsUpdating(true);
            const response = await configurationAPI.updateDesignationsForParticularRole({ roleId: roleForDesignation?.value, reqBody })
            if (response) {
                window.toastr.success("Designations updated successfully");
            }
            setDesignations([]);
            setDesignationsForDuplicationCheck([]);
            setNewDesignations([]);
            setFinalUpdatedDesignations({ deleted: [], added: [] });
            fetchDesignations(roleForDesignation?.value);
        } catch (err) {
            console.log(err);
        }
        setIsUpdating(false);
    };

    const handleDesignationsForParticularRole = async () => {
        try {
            const editedDesignations = [];
            const addedDesignations = newDesignations.filter(d => d.name.trim() !== '').map((newDesignation) => (newDesignation?.name));
            if (addedDesignations.length) {
                designationsForDuplicationCheck?.find((designation) => {
                    if (addedDesignations.includes(designation?.name)) {
                        window.toastr.error(`${designation?.name} already exists`);
                        return true;
                    } else {
                        return false;
                    }
                });
            };

            designations?.forEach((designation) => {
                designationsForDuplicationCheck?.forEach((designationForDuplicationCheck) => {
                    if (designation?.id === designationForDuplicationCheck?.id && designation?.name !== designationForDuplicationCheck?.name) {
                        editedDesignations.push(designation);
                    }
                });
            });

            if (!addedDesignations?.length && !finalUpdatedDesignations?.deleted?.length && !editedDesignations?.length) {
                return;
            };
            const reqBody = {};
            if (finalUpdatedDesignations?.deleted?.length) {
                Swal.fire({
                    text: 'Do you want to delete selected designation(s) and apply other updates, if any?',
                    icon: "warning",
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    customClass: {
                        confirmButton: "btn btn-danger",
                        cancelButton: "btn btn-active-light",
                    },
                }).then(async (result) => {
                    if (result?.value === true) {
                        reqBody.deleted = finalUpdatedDesignations?.deleted;
                        if (editedDesignations?.length) {
                            reqBody.edited = editedDesignations;
                        }
                        if (addedDesignations?.length) {
                            reqBody.added = addedDesignations;
                        }
                        submitDesignationChanges(reqBody);
                    } else {
                        setFinalUpdatedDesignations({ deleted: [], added: [] });
                        setDesignations(designationsForDuplicationCheck);
                        setNewDesignations([]);
                        return;
                    }
                });

            } else {
                if (editedDesignations?.length) {
                    reqBody.edited = editedDesignations;
                }
                if (addedDesignations?.length) {
                    reqBody.added = addedDesignations;
                }
                submitDesignationChanges(reqBody);
            }
        } catch (err) {
            console.error(err);
        }
    };
    const handleDeleteDesignation = ({ id, isNew, designationId }) => {
        if (isNew) {
            setNewDesignations(prev => prev.filter((elem) => elem?.id !== id));
        } else {
            setFinalUpdatedDesignations(prev => ({
                deleted: [...prev.deleted, designationId],
                added: prev.added
            }));
            setDesignations(prev => prev.filter((elem) => elem?.id !== id));
        }
    };

    const renderRoles = () =>
        roles?.map(role => ({
            label: role?.name,
            value: role?.id,
        })) || [];

    return (
        <div className="card card-flush mb-4 py-4">
            <div className="card-header">
                <div className="card-title">
                    <h4>Designation</h4>
                </div>
            </div>
            <div className="card-toolbar m-0 px-9">
                <label htmlFor="roles">
                    Role {rolesLoading && <span className="spinner-border spinner-border-sm" />}
                </label>
                <Select
                    className="mt-1"
                    name="roles"
                    options={renderRoles()}
                    isClearable
                    value={roleForDesignation}
                    onChange={setRoleForDesignation}
                />
                <div className="mt-4">
                    {designationsLoading && designationsForDuplicationCheck.length === 0 &&(<span className="spinner-border spinner-border-sm" />)}
                    {(designations.length > 0 || newDesignations.length > 0) && roleForDesignation?.value && (
                        <>
                            <div>Designation {designationsLoading && <span className="spinner-border spinner-border-sm" />}</div>
                            {designations.map((designation) => (
                                <div key={designation.id} className="mt-1 form-group d-flex flex-wrap align-items-center gap-2">
                                    <input
                                        type="text"
                                        className="form-control mw-100 w-75 mb-2"
                                        value={designation.name}
                                        onChange={(e) => handleDesignationChange(designation.id, e.target.value, false)}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-icon btn-light-danger"
                                        onClick={() => handleDeleteDesignation({ id: designation?.id, isNew: false, designationId: designation.id })}
                                    >
                                        <span className="svg-icon svg-icon-1">
                                            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="7.05" y="15.5356" width="12" height="2" rx="1" transform="rotate(-45 7.05 15.5356)" fill="currentColor" />
                                                <rect x="8.46447" y="7.05029" width="12" height="2" rx="1" transform="rotate(45 8.46447 7.05029)" fill="currentColor" />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            ))}
                            {newDesignations.map((designation) => (
                                <div key={designation.id} className="mt-1 form-group d-flex flex-wrap align-items-center gap-2">
                                    <input
                                        type="text"
                                        className="form-control mw-100 w-75 mb-2"
                                        value={designation.name}
                                        onChange={(e) => handleDesignationChange(designation.id, e.target.value, true)}
                                        placeholder="Enter designation"
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-icon btn-light-danger"
                                        onClick={() => handleDeleteDesignation({ id: designation?.id, isNew: true })}
                                    >
                                        <span className="svg-icon svg-icon-1">
                                            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="7.05" y="15.5356" width="12" height="2" rx="1" transform="rotate(-45 7.05 15.5356)" fill="currentColor" />
                                                <rect x="8.46447" y="7.05029" width="12" height="2" rx="1" transform="rotate(45 8.46447 7.05029)" fill="currentColor" />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            ))}
                        </>
                    )}
                </div>
                <div className="mt-2 float-end">
                    <button
                        type="button"
                        className="btn btn-sm btn-light me-4"
                        onClick={handleAddDesignationInput}
                        disabled={!roleForDesignation?.value}
                    >
                        <span className="svg-icon svg-icon-2">
                            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor" />
                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                            </svg>
                        </span>
                        Add another
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={handleDesignationsForParticularRole}
                        disabled={rolesLoading || designationsLoading || isUpdating}
                    >
                        <i className="fas fa-save"></i>
                        Save {isUpdating && (<span className="spinner-border spinner-border-sm" />)}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DesignationConfiguration;
